import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getItemOperation from 'owa-service/lib/operation/getItemOperation';
import getItemRequest from 'owa-service/lib/factory/getItemRequest';
import getRequestOptions from './getRequestOptions';
import type Item from 'owa-service/lib/contract/Item';
import itemId from 'owa-service/lib/factory/itemId';
import type ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import type PropertyPath from 'owa-service/lib/contract/PropertyPath';

export default async function getItem(
    targetMailbox: string,
    id: string,
    additionalProperties?: PropertyPath[]
): Promise<Item> {
    const response = await getItemOperation(
        {
            Header: getJsonRequestHeader(),
            Body: getItemRequest({
                ItemIds: [itemId({ Id: id })],
                ItemShape: itemResponseShape({
                    BaseShape: 'IdOnly',
                    AdditionalProperties: additionalProperties,
                }),
            }),
        },
        getRequestOptions(targetMailbox)
    );

    return (response?.Body?.ResponseMessages?.Items?.[0] as ItemInfoResponseMessage)?.Items?.[0];
}
